// English for the documents area. Key: exact Macedonian text passed to t().
const en = {
  // Sidebar / settings
  'Напреден режим': 'Advanced mode',
  'ИСКЛ': 'OFF',
  'ВКЛ': 'ON',
  'Печати': 'Print',
  'Ажурирај': 'Update',
  'Зачувај нацрт': 'Save draft',
  'Подесувања': 'Settings',
  '+ Додади ред': '+ Add row',
  'Рекламации вкл.': 'Complaints note on',
  'Рекламации искл.': 'Complaints note off',
  'Напомена вкл.': 'Note on',
  'Напомена искл.': 'Note off',
  'Подножје вкл.': 'Footer on',
  'Подножје искл.': 'Footer off',
  'Прикажи полиња': 'Display fields',
  'Испратница бр.': 'Delivery note no.',
  'Подигнал': 'Picked up by',
  'Возило': 'Vehicle',
  'Комерцијалист': 'Sales rep',
  'Отстрани ред': 'Remove row',
  'Цена: {price}': 'Price: {price}',

  // Breadcrumbs
  'Финансии': 'Finance',
  'Едноставни фактури': 'Simple invoices',
  'Уреди фактура #{number}': 'Edit invoice #{number}',
  'Уреди фактура': 'Edit invoice',
  'Нова фактура': 'New invoice',

  // Invoice alerts / validation
  'Фактура креирана од испратница': 'Invoice created from delivery note',
  'Фактурата е пополнета со податоци од испратница #{number}': 'The invoice was filled in with data from delivery note #{number}',
  'Партнер: {partner} • Ставки: {count}': 'Partner: {partner} • Items: {count}',
  'Н/П': 'N/A',
  'Грешка при вчитување на испратницата': 'Error loading the delivery note',
  'Не може да се вчитаат податоците за испратницата. Ве молиме обидете се повторно.': 'Could not load the delivery note data. Please try again.',
  'Бројот на фактурата е задолжителен': 'Invoice number is required',
  'Ве молиме изберете партнер од листата': 'Please select a partner from the list',
  'Датумот на фактурата е задолжителен': 'Invoice date is required',
  'Потребна е барем една валидна ставка со назив, количина и цена': 'At least one valid item with a name, quantity and price is required',
  'Ве молиме пополнете ги сите ставки или отстранете ги празните редови пред зачувување': 'Please fill in all items or remove the empty rows before saving',
  'Ве молиме пополнете ги сите ставки или отстранете ги празните редови пред зачувување.': 'Please fill in all items or remove the empty rows before saving.',
  'Грешка при валидација': 'Validation error',
  'Ве молиме поправете ги следниве грешки:': 'Please fix the following errors:',
  'Непополнети ставки': 'Incomplete items',
  'Ве молиме најавете се за да зачувате фактури.': 'Please log in to save invoices.',
  'Неуспешна подготовка на податоците за фактурата. Ве молиме проверете за невалидни податоци.': 'Failed to prepare the invoice data. Please check for invalid data.',
  'Генерирање PDF': 'Generating PDF',
  'Се креира PDF датотека за Вашата фактура...': 'Creating a PDF file for your invoice...',
  'PDF предупредување': 'PDF warning',
  'Фактурата е успешно зачувана, но генерирањето PDF не успеа: {error}': 'The invoice was saved, but PDF generation failed: {error}',
  'Фактура #{number} е успешно ажурирана како нацрт!': 'Invoice #{number} was updated as a draft!',
  'Фактура #{number} е успешно ажурирана како завршена!': 'Invoice #{number} was updated as complete!',
  'Фактура #{number} е успешно зачувана како нацрт!': 'Invoice #{number} was saved as a draft!',
  'Фактура #{number} е успешно зачувана како завршена!': 'Invoice #{number} was saved as complete!',
  'Системски ID: {id} • Вкупно: {total}': 'System ID: {id} • Total: {total}',
  'Системски ID: {id} • Вкупно: {total} • Формуларот е исчистен за следната фактура.': 'System ID: {id} • Total: {total} • The form has been cleared for the next invoice.',
  'Фактурата е ажурирана!': 'Invoice updated!',
  'Фактурата е зачувана!': 'Invoice saved!',
  'Неуспешно зачувување на фактурата. Ве молиме проверете ја интернет врската и дали серверот работи.': 'Failed to save the invoice. Please check your internet connection and whether the server is running.',
  'Неуспешно зачувување на фактурата. Настана грешка на серверот. Ве молиме обидете се повторно или контактирајте поддршка.': 'Failed to save the invoice. A server error occurred. Please try again or contact support.',
  'Неуспешно зачувување на фактурата. Некои задолжителни полиња недостасуваат или се невалидни.': 'Failed to save the invoice. Some required fields are missing or invalid.',
  'Неуспешно зачувување на фактурата. {error}': 'Failed to save the invoice. {error}',
  'Неуспешно зачувување': 'Save failed',

  // Delivery note alerts / validation
  'Бројот на испратницата е задолжителен': 'Delivery note number is required',
  'Името на примачот е задолжително': 'Recipient name is required',
  'Датумот на испорака е задолжителен': 'Delivery date is required',
  'Потребна е барем една валидна ставка со назив и количина': 'At least one valid item with a name and quantity is required',
  'Ве молиме најавете се за да пристапите до оваа испратница.': 'Please log in to access this delivery note.',
  'Ве молиме најавете се за да пристапите до оваа страница.': 'Please log in to access this page.',
  'Неуспешно вчитување': 'Loading failed',
  'Не може да се вчита испратницата за уредување.': 'Could not load the delivery note for editing.',
  'Не може да се вчитаат податоците за испратницата.': 'Could not load the delivery note data.',
  'Грешка при вчитување': 'Loading error',
  'Настана грешка при вчитување на испратницата.': 'An error occurred while loading the delivery note.',
  'Ве молиме најавете се за да зачувате испратници.': 'Please log in to save delivery notes.',
  'Неуспешна подготовка на податоците за испратницата. Ве молиме проверете за невалидни податоци.': 'Failed to prepare the delivery note data. Please check for invalid data.',
  'Испратница #{number} е успешно ажурирана како нацрт!': 'Delivery note #{number} was updated as a draft!',
  'Испратница #{number} е успешно ажурирана како конечна!': 'Delivery note #{number} was updated as final!',
  'Испратница #{number} е успешно зачувана како нацрт!': 'Delivery note #{number} was saved as a draft!',
  'Испратница #{number} е успешно зачувана како конечна!': 'Delivery note #{number} was saved as final!',
  'Испратницата е зачувана!': 'Delivery note saved!',
  'Системски ID: {id} • PDF е генериран и зачуван на серверот.': 'System ID: {id} • The PDF was generated and saved on the server.',
  'Неуспешно ажурирање на испратницата': 'Failed to update the delivery note',
  'Неуспешно зачувување на испратницата': 'Failed to save the delivery note',
  'Откриен е дупликат број': 'Duplicate number detected',
  'Грешка при автентикација': 'Authentication error',
  'Неуспешно креирање на партнер': 'Failed to create the partner',
  'Вчитување на испратницата...': 'Loading delivery note...',
  'Испратницата не е пронајдена': 'Delivery note not found',
  'Испратницата што ја барате не може да се пронајде.': 'The delivery note you are looking for could not be found.',

  // Delivery note list
  'Не е пронајден токен за автентикација. Ве молиме најавете се.': 'No authentication token found. Please log in.',
  'Неуспешно вчитување на испратниците: {status} {statusText}': 'Failed to load delivery notes: {status} {statusText}',
  'Испратницата не е избришана': 'The delivery note was not deleted',
  'Испратницата е избришана.': 'The delivery note was deleted.',
  'Нема достапно PDF за оваа испратница': 'No PDF available for this delivery note',
  'Неуспешно ажурирање на статусот: {status} {statusText}': 'Failed to update the status: {status} {statusText}',
  'Неуспешно ажурирање на статусот: {error}': 'Failed to update the status: {error}',
  'Во чекање': 'Pending',
  'Издадена': 'Issued',
  'Испорачана': 'Delivered',
  'Откажана': 'Cancelled',
  'Број на испратница': 'Delivery note no.',
  'Примач': 'Recipient',
  'Датум на испратница': 'Delivery note date',
  'Адреса на примач': 'Recipient address',
  'Белешка': 'Note',
  'Креирано од': 'Created by',
  'Креирана на': 'Created on',
  'Акции': 'Actions',
  'Преглед на PDF': 'Preview PDF',
  'Не може да се креира фактура за откажана испратница': 'Cannot create an invoice for a cancelled delivery note',
  'Креирај фактура': 'Create invoice',
  'Вчитување на испратници...': 'Loading delivery notes...',
  'Грешка при вчитување на испратниците': 'Error loading delivery notes',
  'Обиди се пак': 'Try again',
  'Број на испратница...': 'Delivery note number...',
  'Партнер': 'Partner',
  'Сите партнери': 'All partners',
  'Избриши ги сите филтери': 'Clear all filters',
  'Примени филтери': 'Apply filters',
  'Филтрирај': 'Filter',
  'Нова испратница': 'New delivery note',
  'Нова Испратница': 'New delivery note',
  'Испратници': 'Delivery notes',
  'Избери колони': 'Choose columns',
  'Колони': 'Columns',
  'Прикажи колони': 'Show columns',
  'Освежи ја листата': 'Refresh the list',
  'Освежи': 'Refresh',
  'Експортирај ги испратниците во CSV': 'Export delivery notes to CSV',
  'Експорт': 'Export',
  'Нема пронајдени испратници': 'No delivery notes found',
  'Вчитување на ставки...': 'Loading items...',
  'Назив на производ': 'Product name',
  'Непознат производ': 'Unknown product',
  'Нема белешка': 'No note',
  'Нема пронајдени ставки за оваа испратница': 'No items found for this delivery note',
  'Избриши испратница': 'Delete delivery note',
  'Дали сте сигурни дека сакате да ја избришете испратницата „{number}“?': 'Are you sure you want to delete delivery note "{number}"?',
  'Се брише...': 'Deleting...',
  'Успешно': 'Success',

  // PDF generation (printDeliveryNote)
  'Недостасуваат информации': 'Missing information',
  'Бројот на документот не е внесен!': 'The document number has not been entered!',
  'Недостасуваат ставки': 'Missing items',
  'Мора да имате барем една ставка!': 'You must have at least one item!',
  'Ве молиме почекајте додека се генерира PDF документот...': 'Please wait while the PDF document is generated...',
  'Прикачување PDF': 'Uploading PDF',
  'PDF документот се зачувува на серверот...': 'Saving the PDF document to the server...',
  'Предупредување при прикачување': 'Upload warning',
  'PDF документот е успешно генериран, но не успеа прикачувањето на серверот: {error}': 'The PDF document was generated, but uploading it to the server failed: {error}',
  'Неуспешно генерирање PDF': 'PDF generation failed',
  'Не може да се генерира PDF. Ве молиме обидете се повторно.': 'Could not generate the PDF. Please try again.',
};

export default en;
